import React, { useState, useEffect } from "react";
import moment from "moment";
import { FiCopy, handleCopy } from "../commonFunction/handleCopy";

function DateToTimestamp() {
  const [text, setText] = useState(null);
  const [text2, setText2] = useState(null);
  const [copy, setCopy] = useState(false);

  useEffect(() => {
    const currentDatetime = moment().format("YYYY-MM-DDTHH:mm:ss");
    setText(currentDatetime);
    setText2(convertToTimestamp(currentDatetime));
  }, []);

  const convertToTimestamp = (datetimeString) => {
    const date = new Date(datetimeString);
    return Math.floor(date.getTime() / 1000);
  };

  const handleOnChange = (e) => {
    setCopy(false);
    setText(e.target.value);
  };

  const handleOnSubmit = () => {
    if (text) {
      setCopy(false);
      setText2(convertToTimestamp(text));
    }
  };

  return (
    <>
      <div>
        <div className="children-box-alignment">
          <div className="image-cropper-box-design-upload-two">
            <div className="timeStamp-text-area">
              <input
                type="datetime-local"
                step="1" // Include seconds in the input
                value={text}
                onChange={handleOnChange}
              />
            </div>
          </div>
          <div className="instruction-image-Resize">
            <span>
              * Modify the date & time and click the convert button to see
              result.
            </span>
          </div>
          <div className="button lowercase-center-alignment">
            <button onClick={handleOnSubmit}>Convert</button>
          </div>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="copy-textarea-icon-alignment">
                <div onClick={handleCopy}>
                  <FiCopy />
                </div>
                {copy && text2 && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
            )}
            <div className="timeStamp-text-area">
              <input
                value={text2}
                disabled={true}
                placeholder={"Timestamp Value"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DateToTimestamp;
